import React from 'react';
import "../../asset/style/scanner/scanner.css";
import {progressStage, specimenType} from "../../utils/const";
import SetScanParamsBloodView from './scanWorkflow/set_scan_params_view_blood_new';
import {connect} from "react-redux";
import {ScanWorkflowNew} from "./scan_workflow_new";

class BloodWorkflow extends ScanWorkflowNew {

    setSpecimenType = (res) => res.defaultConfig.specimenType = specimenType.BLOOD;

    specimType = specimenType.BLOOD;

    handleProgressChange = (stage) => {
        this.setState({
            currentProcessStage: progressStage.stage,
        })
        this.props.history.push("/scannerflow/" + this.props.match.params.id + "/blood-scan/" + stage + "/");
    }

    setScanParams = () => <SetScanParamsBloodView
        handleProgressChange={this.handleProgressChange}
        device_id={this.props.match.params.id}
        currentProcessIndex={this.props.match.params.stage}
        previews={this.props.previews}
        progressStage={this.props.match.params.stage}
        navigateToScannerDashboard={this.navigateToScannerDashboard}
        defaultConfig={this.state.defaultConfig}
    />

}

const mapStateToProps = (state) => {
    return {
        previews : state.previewStatusReducer,
        deviceProperties: state.deviceAlert.deviceProperties,
        deviceStatus: state.deviceStatusReducer,
    };
};

export default connect(mapStateToProps)(BloodWorkflow);
